<template>
    <div>
    <v-tabs
            centered
            v-model="tab"
            background-color="transparent"
            style="z-index: 10;    position: relative;margin-top:100px;"


            dark
    >
        <v-tab>
            Action-cards
        </v-tab>
        <v-tab>
            Collection-cards
        </v-tab>

    </v-tabs>

    <v-tabs-items style="background:transparent;" dark v-model="tab" >
        <v-tab-item>

            <v-card
                    dark
                    flat
                    tile
                    style="background:#121212;">
                <v-card-text class="mx-auto" style="text-align: center;max-width:600px;">
                    <div>
                        Du skapar själv dina egna Action-kort. Dessa kort går att använda och lösa in under streams, ett använt kort försvinner. Du bestämmer själv vilka kort som ska göra vad.


                    </div>
                </v-card-text>




                <v-card
                                flat
                                class="mx-auto mt-2 mb-auto"
                                max-width="438"
                                color="grey darken-3"
                                style="background:transparent !important;"
                        >   <v-card-title>
                            <v-spacer></v-spacer>


                            <v-spacer></v-spacer>
                        </v-card-title>



                            <v-hover >
                            <template v-slot:default="{ hover }">
                                <v-img
                                        class="mx-auto"
                                        width="338"
                                        height="238"
                                        :src="use_alternative_image? alternative_image: chip_image"
                                        @error="imageLoadError"

                                >




                                    <v-fade-transition>
                                        <v-overlay
                                                v-if="hover"
                                                absolute
                                                :color="chip_color"
                                        >
                                            <v-btn @click="getFile"> <v-icon>image</v-icon>Byt bild</v-btn>
                                        </v-overlay>
                                    </v-fade-transition>
                                </v-img>

                            </template>
                        </v-hover>
                    <v-card-subtitle style="text-align: center;">
                        {{chip_droprate}}% droprate
                    </v-card-subtitle>




                            <v-card-actions>
                                <v-btn class="mx-auto my-4" @click="createCard" outlined :color="chip_color" :disabled="action_cards[tab_action].length>7">
                                    <v-icon left >mdi-plus</v-icon> Skapa kort
                                </v-btn>
                            </v-card-actions>

                        </v-card>

                <v-tabs
                        v-model="tab_action"
                        background-color="transparent"
                        dark
                        centered


                >
                    <v-tab  :style="[this.tab_action===0 ? {'color': '#039234'} : {'background': 'transparent'}]" >
                        Vanlig
                    </v-tab>
                    <v-tab :style="[this.tab_action===1 ? {'color': '#254292'} : {'background': 'transparent'}]">
                        Rare
                    </v-tab>
                    <v-tab :style="[this.tab_action===2 ? {'color': '#6a0792'} : {'background': 'transparent'}]">
                        Epic
                    </v-tab>
                    <v-tab  :style="[this.tab_action===3 ? {'color': '#a65014'} : {'background': 'transparent'}]">
                        Legendary
                    </v-tab>
                </v-tabs>

                <v-card-subtitle>{{action_cards[tab_action].length}}/8</v-card-subtitle>

                <v-tabs-items  dark style="background: transparent;" v-model="tab_action">
                    <video id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="mix-blend-mode: hard-light;">
                        <source :src="require('../assets/white_flare.webm')" type="video/webm">

                    </video>


                    <v-tab-item style="background: rgb(0,0,0); background: linear-gradient(29deg, rgba(0,0,0,0.31416316526610644) 0%, rgba(56,204,55,0.51) 100%);min-height:400px;">

                        <EditAction :data=action_cards[0]
                                    v-on:actionClicked="actionClicked"
                                    :key="action_key"
                                    v-on:deleted="deleted"
                                    style="position:relative;z-index: 1;top">

                        </EditAction>
                    </v-tab-item>
                    <v-tab-item style="background: rgb(0,0,0); background: linear-gradient(29deg, rgba(0,0,0,0.31416316526610644) 0%, rgba(3,0,204,0.51) 100%);min-height:400px;">

                        <EditAction :data=action_cards[1]
                                    v-on:actionClicked="actionClicked"
                                    :key="action_key"
                                    v-on:deleted="deleted"
                                    style="position:relative;z-index: 1;">

                        </EditAction>
                    </v-tab-item>
                    <v-tab-item style="background: rgb(0,0,0); background: linear-gradient(29deg, rgba(0,0,0,0.31416316526610644) 0%, rgba(123,14,177,0.69) 100%);min-height:400px;">

                        <EditAction :data=action_cards[2]
                                    v-on:actionClicked="actionClicked"
                                    :key="action_key"
                                    v-on:deleted="deleted"
                                    style="position:relative;z-index: 1;">

                        </EditAction>
                    </v-tab-item>
                    <v-tab-item style="background: rgb(0,0,0); background: linear-gradient(29deg, rgba(0,0,0,0.31416316526610644) 0%, rgba(196,105,27,0.73) 100%);min-height:400px;">

                        <EditAction :data=action_cards[3]
                                    v-on:actionClicked="actionClicked"
                                    :key="action_key"
                                    v-on:deleted="deleted"
                                    style="position:relative;z-index: 1;">

                        </EditAction>
                    </v-tab-item>
                </v-tabs-items>

            </v-card>

        </v-tab-item>
        <v-tab-item>
            <v-card
                    dark
                    flat
                    tile
                    style="background:#121212;">
                <v-card-text class="mx-auto" style="text-align: center;max-width:600px;">
                    <div>
                        Collection-kort skapar vi på Hihat, du behöver bara välja ut en snygg bild på dig själv eller något som representerar dig. Dessa kort går att byta, flexa och kommer i många olika varianter från olika kollektioner.

                    </div>
                </v-card-text>




                <v-card
                        flat
                        class="mx-auto mt-2 mb-auto"
                        max-width="438"
                        color="grey darken-3"
                        style="background:transparent !important;"
                >   <v-card-title>
                    <v-spacer></v-spacer>


                    <v-spacer></v-spacer>
                </v-card-title>



                    <v-hover >
                        <template v-slot:default="{ hover }">
                            <v-img
                                    class="mx-auto"
                                    width="338"
                                    height="238"
                                    :src="use_alternative_image_col? alternative_image_col: chip_image_col"
                                    @error="imageLoadError_col"

                            >




                                <v-fade-transition>
                                    <v-overlay
                                            v-if="hover"
                                            absolute
                                            :color="chip_color"
                                    >
                                        <v-btn @click="getFileCollection"> <v-icon>image</v-icon>Byt bild</v-btn>
                                    </v-overlay>
                                </v-fade-transition>
                            </v-img>

                        </template>
                    </v-hover>

                    <p  class="font-weight-light caption" style="text-align: center;">
                        Denna bild kommer pryda alla Collection-kort tillhörande dig

                    </p>
                </v-card>
                <v-row>
                    <v-col>
                        <CollectionCard
                                :key="collection_key"

                                :data="sampleCard2D"
                                v-on:clicked="collection_show=true"
                        ></CollectionCard>
                    </v-col>
                </v-row>
            </v-card>
        </v-tab-item>

    </v-tabs-items>
        <ActioncardHolderEdit
                :show=action_show
                :card_data=action_card_selected
                v-on:hide="action_show=false"
                v-on:deleted="deleted"
                v-on:update="update_actioncard"
                v-on:refresh="get_my_action_cards"

        >

        </ActioncardHolderEdit>
        <CollectioncardHolder

                :show_arrows=false
                :show=collection_show
                :card_data="sampleCard3D"
                v-on:hide="collection_show=false"

        ></CollectioncardHolder>
        <input id="imageInputActionCard" style="display:none;" type="file" accept="image/*" v-on:change="readInputFile">
        <input id="imageInputCollectionCard" style="display:none;" type="file" accept="image/*" v-on:change="readInputFile2">

    </div>
</template>

<script>
    import EditAction from '../components/EditAction'
    import ActioncardHolderEdit from '../components/ActioncardHolderEdit'
    import CollectioncardHolder from '../components/CollectioncardHolder'
    import CollectionCard from '../components/CollectionCard'
    export default {
        components: {EditAction,ActioncardHolderEdit,CollectioncardHolder,CollectionCard},
        name: "Studio",
        data(){
            return {
                tab:0,
                tab_action:0,
                action_show:false,
                collection_show:false,
                action_card_selected:null,
                use_alternative_image:false,
                use_alternative_image_col:false,
                overlay: false,
                action_key:0,
                collection_key:0,
                newImages:[null,null,null,null],
                newCollectionImage:null,
                action_cards:[[],[],[],[]]



            }
        },
        methods:{
            update_actioncard(data){
                let cardIndex=this.action_cards[data.RANK].findIndex(card => card.ACMID === data.ACMID);
                this.action_cards[data.RANK][cardIndex].DELETED=data.DELETED;
                this.action_cards[data.RANK][cardIndex].NAME=data.NAME;
                this.action_cards[data.RANK][cardIndex].TEXT=data.TEXT;
                this.action_cards[data.RANK][cardIndex].VIDEO=data.VIDEO;
                this.get_my_action_cards();




            },

            get_my_action_cards(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/my_activity_cards';

                http.open('GET', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        if(http.responseText!=="no data"){
                            let data = JSON.parse(http.response);
                            self.set_my_action_cards(data);
                        }







                    }

                };
                http.send();
            },
            set_my_action_cards(data) {
                this.action_cards=[[],[],[],[]];
                for (let i = 0; i < data.data.length; i++) {
                    if (data.data[i].VIDEO === null) {
                        data.data[i].VIDEO = {
                            "url": null,
                            "video_id": null,
                            "volume": 100,
                            "opacity": 100,
                            "start": 0,
                            "end": 10

                        }
                    } else {
                        try {
                            data.data[i].VIDEO = JSON.parse(data.data[i].VIDEO);
                            if(data.data[i].VIDEO.video_id){
                                data.data[i].VIDEO.url = "https://www.youtube.com/watch?v=" + data.data[i].VIDEO.video_id;
                            }
                            else{
                                data.data[i].VIDEO.url = "";

                            }

                        } catch (e) {
                            data.data[i].VIDEO = {
                                "url": null,
                                "video_id": null,
                                "volume": 100,
                                "opacity": 100,
                                "start": 0,
                                "end": 10

                            }
                        }
                    }

                    this.action_cards[data.data[i].RANK].push(data.data[i])
                }
            },

            deleted:function(){
              this.action_key+=1;
            },
            getFile:function(){
                document.getElementById("imageInputActionCard").click();
            },
            getFileCollection:function(){
                document.getElementById("imageInputCollectionCard").click();
            },
            actionClicked:function(payload){
                this.action_card_selected=payload;
                this.action_show=true;
            },
            imageLoadError:function(){
                this.use_alternative_image=true;
                this.newImages[this.tab_action]=null;
            },
            imageLoadError_col:function(){
                this.use_alternative_image_col=true;
                this.newCollectionImage=null;
            },
            readInputFile:function(file){
                let input = file.target;
                let self=this;
                let reader = new FileReader();
                reader.onload = function(){
                    let image=new Image();
                    let dataURL = reader.result;
                    image.onload= function(){
                        var canvas = document.createElement('canvas');
                        canvas.width=675;
                        canvas.height=475;
                        let context = canvas.getContext('2d');
                        context.drawImage(image, 0 ,0, image.width, image.height, 0, 0, 675, 475);
                        self.saveActionImage(canvas.toDataURL(),self.tab_action)
                        self.newImages[self.tab_action]=canvas.toDataURL();
                    }
                    image.src=dataURL;

                };
                reader.readAsDataURL(input.files[0]);
            },
            readInputFile2:function(file){
                let input = file.target;
                let self=this;
                let reader = new FileReader();
                reader.onload = function(){
                    let image=new Image();
                    let dataURL = reader.result;
                    image.onload= function(){
                        var canvas = document.createElement('canvas');
                        canvas.width=675;
                        canvas.height=475;
                        let context = canvas.getContext('2d');
                        context.drawImage(image, 0 ,0, image.width, image.height, 0, 0, 675, 475);
                        self.saveCollectionImage(canvas.toDataURL());
                        self.newCollectionImage=canvas.toDataURL();
                    }
                    image.src=dataURL;

                };
                reader.readAsDataURL(input.files[0]);
            },
            saveActionImage:function(image,rank){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/save_rank_image?';
                let params="RANK="+rank+"&IMAGE="+image;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.reRender();

                    }
                    else if(http.readyState === 4 && http.status === 413){
                        self.$store.commit("update_snackbar","Fel: Bilden är för stor.");


                    }

                };
                http.send(params);
            },
            saveCollectionImage:function(image){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/save_collection_image?';
                let params="IMAGE="+image;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.reRenderCollection();

                    }
                    else if(http.readyState === 4 && http.status === 413){
                        self.$store.commit("update_snackbar","Fel: Bilden är för stor.");


                    }

                };
                http.send(params);
            },
            reRender:function(){
                this.action_key+=1;
                this.use_alternative_image=true;
            },
            reRenderCollection:function(){
                this.collection_key+=1;
                this.use_alternative_image_col=true;
            },
            createCard:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/save_card?';
                let params="RANK="+this.tab_action+"&TEXT="+"Nytt kort"+"&NAME="+"Namnlöst";
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.action_key+=1;
                        self.get_my_action_cards();
                        setTimeout(function(){
                            self.action_card_selected=self.action_cards[self.tab_action][self.action_cards[self.tab_action].length-1]
                            self.action_show=true;

                        },500)

                    }

                };
                http.send(params);
            }

        },
        computed:{
            chip_text:function(){
                return ["Vanlig","Rare","Epic","Legendary"][this.tab_action]
            },
            chip_color:function(){
                return ["green","blue","purple","orange"][this.tab_action]
            },
            chip_droprate:function(){
                return ["47","37","15","1"][this.tab_action]
            },
            chip_image:function(){
                let random=(parseInt(Math.random()*1000)).toString();
                return `/api/images/cards/streamer_images/${this.$store.state.STREAMER.SID}/${this.tab_action}.png?random=${random}`
            },
            chip_image_col:function(){
                let random=(parseInt(Math.random()*1000)).toString();
                return `/api/images/cards/streamer_images/${this.$store.state.STREAMER.SID}/avatar.png?random=${random}`
            },
            alternative_image:function(){
                if(this.newImages[this.tab_action]!==null){
                    return this.newImages[this.tab_action]
                }
                else{
                    return "/api/images/no_image.png"
                }
            },
            alternative_image_col:function(){
                if(this.newCollectionImage!==null){
                    return this.newCollectionImage
                }
                else{
                    return "/api/images/no_image.png"
                }
            },
            sampleCard3D:function(){
                if(this.collection_show){
                    let data={};
                    data["FLOAT_X"]=Math.random();
                    data["FLOAT_Y"]=Math.random();
                    data["COID"]=0;
                    data["SHININESS"]=1;
                    data["SPECULAR"]="purple";
                    data["RANK_VALUE"]=0;
                    data["STID"]=this.$store.state.STREAMER.SID;
                    data["USER_NAME"]=this.$store.state.STREAMER.USER_NAME;
                    data["NAME"]="Test-kort";
                    data["TYPE"]="TEST";
                    data["DESC"]="Detta är ett test-kort för att visa hur din profilbild ser ut på ett collection-kort. Du kan även testa din anslutning till OBS genom att flexa kortet.";
                    return data;
                }
                else{
                    return null;
                }

            },
            sampleCard2D:function(){
                    let data={};
                    data["FLOAT_X"]=Math.random();
                    data["FLOAT_Y"]=Math.random();
                    data["COID"]=0;
                    data["SHININESS"]=1;
                    data["SPECULAR"]="purple";
                    data["RANK_VALUE"]=0;
                    data["STID"]=this.$store.state.STREAMER.SID;
                    data["USER_NAME"]=this.$store.state.STREAMER.USER_NAME;
                    data["NAME"]="Test-kort";
                    data["TYPE"]="TEST";
                    data["DESC"]="Detta är ett test-kort för att visa hur din profilbild ser ut på ett collection-kort. Du kan även testa din anslutning till OBS genom att flexa kortet.";
                    return data;
                }


            },
        mounted:function(){
            document.title="Hihat - Studio";

            this.get_my_action_cards();
        },

        watch:{
            chip_image:function(){
                this.use_alternative_image=false;
            }
        }
    }
</script>

<style scoped>

</style>
